import { CONSENT_MODES } from 'api/consent-modes/modes';

const OPTIONS = [
  { value: CONSENT_MODES.ace, text: 'Advanced Consent Enforcement' },
  { value: CONSENT_MODES.external, text: 'Externally Managed / None' },
];

export default OPTIONS;
